export default "__VITE_PUBLIC_ASSET__f2007f72__"